import { buildScopedI18n } from '../../../../../utils/buildScopedI18n';
import eppValidatorsEsCL from './locales/es-CL.json';
import eppValidatorsEnUS from './locales/en-US.json';
import eppValidatorsPtBR from './locales/pt-BR.json';

export const eppValidatorsI18n = buildScopedI18n({
  esCL: eppValidatorsEsCL,
  enUS: eppValidatorsEnUS,
  ptBR: eppValidatorsPtBR,
});
